/* vue-onsenui v2.7.2 - 2022-12-27 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('onsenui'), require('onsenui/esm/elements/ons-toolbar'), require('onsenui/esm/elements/ons-bottom-toolbar'), require('onsenui/esm/elements/ons-toolbar-button'), require('onsenui/esm/elements/ons-alert-dialog-button'), require('onsenui/esm/elements/ons-button'), require('onsenui/esm/elements/ons-icon'), require('onsenui/esm/elements/ons-card'), require('onsenui/esm/elements/ons-list'), require('onsenui/esm/elements/ons-list-item'), require('onsenui/esm/elements/ons-list-title'), require('onsenui/esm/elements/ons-list-header'), require('onsenui/esm/elements/ons-ripple'), require('onsenui/esm/elements/ons-row'), require('onsenui/esm/elements/ons-col'), require('onsenui/esm/elements/ons-progress-bar'), require('onsenui/esm/elements/ons-progress-circular'), require('onsenui/esm/elements/ons-carousel-item'), require('onsenui/esm/elements/ons-splitter-mask'), require('onsenui/esm/elements/ons-splitter-content'), require('onsenui/esm/elements/ons-splitter'), require('onsenui/esm/elements/ons-switch'), require('onsenui/esm/elements/ons-checkbox'), require('onsenui/esm/elements/ons-input'), require('onsenui/esm/elements/ons-search-input'), require('onsenui/esm/elements/ons-range'), require('onsenui/esm/elements/ons-radio'), require('onsenui/esm/elements/ons-fab'), require('onsenui/esm/elements/ons-speed-dial-item'), require('onsenui/esm/elements/ons-dialog'), require('onsenui/esm/elements/ons-action-sheet'), require('onsenui/esm/elements/ons-action-sheet-button'), require('onsenui/esm/elements/ons-modal'), require('onsenui/esm/elements/ons-toast'), require('onsenui/esm/elements/ons-popover'), require('onsenui/esm/elements/ons-alert-dialog'), require('onsenui/esm/elements/ons-speed-dial'), require('onsenui/esm/elements/ons-carousel'), require('onsenui/esm/elements/ons-tab'), require('onsenui/esm/elements/ons-tabbar'), require('onsenui/esm/elements/ons-back-button'), require('onsenui/esm/elements/ons-navigator'), require('onsenui/esm/elements/ons-splitter-side'), require('onsenui/esm/elements/ons-lazy-repeat'), require('onsenui/esm/elements/ons-select'), require('onsenui/esm/elements/ons-segment'), require('onsenui/esm/elements/ons-pull-hook'), require('onsenui/esm/elements/ons-page')) :
  typeof define === 'function' && define.amd ? define(['onsenui', 'onsenui/esm/elements/ons-toolbar', 'onsenui/esm/elements/ons-bottom-toolbar', 'onsenui/esm/elements/ons-toolbar-button', 'onsenui/esm/elements/ons-alert-dialog-button', 'onsenui/esm/elements/ons-button', 'onsenui/esm/elements/ons-icon', 'onsenui/esm/elements/ons-card', 'onsenui/esm/elements/ons-list', 'onsenui/esm/elements/ons-list-item', 'onsenui/esm/elements/ons-list-title', 'onsenui/esm/elements/ons-list-header', 'onsenui/esm/elements/ons-ripple', 'onsenui/esm/elements/ons-row', 'onsenui/esm/elements/ons-col', 'onsenui/esm/elements/ons-progress-bar', 'onsenui/esm/elements/ons-progress-circular', 'onsenui/esm/elements/ons-carousel-item', 'onsenui/esm/elements/ons-splitter-mask', 'onsenui/esm/elements/ons-splitter-content', 'onsenui/esm/elements/ons-splitter', 'onsenui/esm/elements/ons-switch', 'onsenui/esm/elements/ons-checkbox', 'onsenui/esm/elements/ons-input', 'onsenui/esm/elements/ons-search-input', 'onsenui/esm/elements/ons-range', 'onsenui/esm/elements/ons-radio', 'onsenui/esm/elements/ons-fab', 'onsenui/esm/elements/ons-speed-dial-item', 'onsenui/esm/elements/ons-dialog', 'onsenui/esm/elements/ons-action-sheet', 'onsenui/esm/elements/ons-action-sheet-button', 'onsenui/esm/elements/ons-modal', 'onsenui/esm/elements/ons-toast', 'onsenui/esm/elements/ons-popover', 'onsenui/esm/elements/ons-alert-dialog', 'onsenui/esm/elements/ons-speed-dial', 'onsenui/esm/elements/ons-carousel', 'onsenui/esm/elements/ons-tab', 'onsenui/esm/elements/ons-tabbar', 'onsenui/esm/elements/ons-back-button', 'onsenui/esm/elements/ons-navigator', 'onsenui/esm/elements/ons-splitter-side', 'onsenui/esm/elements/ons-lazy-repeat', 'onsenui/esm/elements/ons-select', 'onsenui/esm/elements/ons-segment', 'onsenui/esm/elements/ons-pull-hook', 'onsenui/esm/elements/ons-page'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.VueOnsen = factory(global.ons));
})(this, (function (ons) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var ons__default = /*#__PURE__*/_interopDefaultLegacy(ons);

  function setup (ons) {
    return Object.keys(ons).filter(function (k) {
      return [/^is/, /^disable/, /^enable/, /^mock/, /^open/, /^set/, /animit/, /elements/, /GestureDetector/, /notification/, /orientation/, /platform/, /ready/].some(function (t) {
        return k.match(t);
      });
    }).reduce(function (r, k) {
      r[k] = ons[k];
      return r;
    }, {
      _ons: ons
    });
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var capitalize = function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  var camelize = function camelize(string) {
    return string.toLowerCase().replace(/-([a-z])/g, function (m, l) {
      return l.toUpperCase();
    });
  };
  var eventToHandler = function eventToHandler(name) {
    return '_on' + capitalize(name);
  };
  var handlerToProp = function handlerToProp(name) {
    return name.slice(2).charAt(0).toLowerCase() + name.slice(2).slice(1);
  };

  /* Private */

  var _setupDBB = function _setupDBB(component) {
    var dbb = 'onDeviceBackButton'; // Call original handler or parent handler by default

    var handler = component[dbb] || component.$el[dbb] && component.$el[dbb]._callback || function (e) {
      return e.callParentHandler();
    };

    component.$el[dbb] = function (event) {
      var runDefault = true;
      component.$emit(handlerToProp(dbb), _objectSpread2(_objectSpread2({}, event), {}, {
        preventDefault: function preventDefault() {
          return runDefault = false;
        }
      }));
      runDefault && handler(event);
    };

    component._isDBBSetup = true;
  };
  /* Public */
  // Device Back Button Handler


  var deriveDBB = {
    mounted: function mounted() {
      _setupDBB(this);
    },
    // Core destroys deviceBackButton handlers on disconnectedCallback.
    // This fixes the behavior for <keep-alive> component.
    activated: function activated() {
      this._isDBBSetup === false && _setupDBB(this);
    },
    deactivated: function deactivated() {
      this._isDBBSetup === true && (this._isDBBSetup = false);
    },
    destroyed: function destroyed() {
      this.$el.onDeviceBackButton && this.$el.onDeviceBackButton.destroy();
    }
  };
  var deriveEvents = {
    computed: {
      unrecognizedListeners: function unrecognizedListeners() {
        var _this = this;

        var name = camelize('-' + this.$options._componentTag.slice(6));
        return Object.keys(this.$listeners || {}).filter(function (k) {
          return (_this.$ons.elements[name].events || []).indexOf(k) === -1;
        }).reduce(function (r, k) {
          r[k] = _this.$listeners[k];
          return r;
        }, {});
      }
    },
    mounted: function mounted() {
      var _this2 = this;

      this._handlers = {};
      (this.$el.constructor.events || []).forEach(function (key) {
        _this2._handlers[eventToHandler(key)] = function (event) {
          // Filter events from different components with the same name
          if (event.target === _this2.$el || !/^ons-/i.test(event.target.tagName)) {
            _this2.$emit(key, event);
          }
        };

        _this2.$el.addEventListener(key, _this2._handlers[eventToHandler(key)]);
      });
    },
    beforeDestroy: function beforeDestroy() {
      var _this3 = this;

      Object.keys(this._handlers).forEach(function (key) {
        _this3.$el.removeEventListener(key, _this3._handlers[key]);
      });
      this._handlers = null;
    }
  };

  /* Private */
  var _toggleVisibility = function _toggleVisibility() {
    if (typeof this.visible === 'boolean' && this.visible !== this.$el.visible) {
      this.$el[this.visible ? 'show' : 'hide'].call(this.$el, this.normalizedOptions || this.options);
    }
  };

  var _teleport = function _teleport() {
    if (!this._isDestroyed && (!this.$el.parentNode || this.$el.parentNode !== document.body)) {
      document.body.appendChild(this.$el);
    }
  };

  var _unmount = function _unmount() {
    var _this = this;

    if (this.$el.visible === true) {
      this.$el.hide().then(function () {
        return _this.$el.remove();
      });
    } else {
      this.$el.remove();
    }
  };
  /* Public */
  // Components that can be shown or hidden


  var hidable = {
    props: {
      visible: {
        type: Boolean,
        "default": undefined // Avoid casting to false

      }
    },
    watch: {
      visible: function visible() {
        _toggleVisibility.call(this);
      }
    },
    mounted: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        return _toggleVisibility.call(_this2);
      });
    },
    activated: function activated() {
      var _this3 = this;

      this.$nextTick(function () {
        return _toggleVisibility.call(_this3);
      });
    }
  }; // Components with 'options' property

  var hasOptions = {
    props: {
      options: {
        type: Object,
        "default": function _default() {
          return {};
        }
      }
    }
  }; // Provides itself to its descendants

  var selfProvider = {
    provide: function provide() {
      return _defineProperty({}, this.$options._componentTag.slice(6), this);
    }
  }; // Common event for Dialogs

  var dialogCancel = {
    mounted: function mounted() {
      var _this4 = this;

      this.$on('dialog-cancel', function () {
        return _this4.$emit('update:visible', false);
      });
    }
  }; // Moves the element to a global position

  var portal = {
    mounted: function mounted() {
      _teleport.call(this);
    },
    updated: function updated() {
      _teleport.call(this);
    },
    activated: function activated() {
      _teleport.call(this);
    },
    deactivated: function deactivated() {
      _unmount.call(this);
    },
    beforeDestroy: function beforeDestroy() {
      _unmount.call(this);
    }
  };
  var modifier = {
    props: {
      modifier: {
        type: [String, Array, Object]
      }
    },
    computed: {
      normalizedModifier: function normalizedModifier() {
        var modifier = this.modifier;

        if (typeof modifier === 'string') {
          return modifier;
        }

        if (Array.isArray(modifier)) {
          return modifier.join(' ');
        }

        if (_typeof(modifier) === 'object') {
          return Object.keys(modifier).reduce(function (acc, key) {
            return acc + (modifier[key] ? " ".concat(key) : '');
          }, '').trim();
        }

        return false;
      }
    }
  };

  var _props, _props2;

  /* Private */
  var model = {
    prop: 'modelProp',
    event: 'modelEvent'
  };
  /* Public */
  // Generic input

  var modelInput = {
    model: model,
    props: (_props = {}, _defineProperty(_props, model.prop, [Number, String]), _defineProperty(_props, model.event, {
      type: String,
      "default": 'input'
    }), _props),
    methods: {
      _updateValue: function _updateValue() {
        if (this[model.prop] !== undefined && this.$el.value !== this[model.prop]) {
          this.$el.value = this[model.prop];
        }
      },
      _onModelEvent: function _onModelEvent(event) {
        this.$emit(model.event, event.target.value);
      }
    },
    watch: _defineProperty({}, model.prop, function () {
      this._updateValue();
    }),
    mounted: function mounted() {
      this._updateValue();

      this.$el.addEventListener(this[model.event], this._onModelEvent);
    },
    beforeDestroy: function beforeDestroy() {
      this.$el.removeEventListener(this[model.event], this._onModelEvent);
    }
  }; // Input with number value

  var modelInputNumber = {
    mixins: [modelInput],
    methods: {
      _onModelEvent: function _onModelEvent(event) {
        this.$emit(model.event, event.target.valueAsNumber);
      }
    }
  }; // Checkable inputs

  var modelCheckbox = {
    mixins: [modelInput],
    props: (_props2 = {}, _defineProperty(_props2, model.prop, [Array, Boolean]), _defineProperty(_props2, model.event, {
      type: String,
      "default": 'change'
    }), _props2),
    methods: {
      _updateValue: function _updateValue() {
        if (this[model.prop] instanceof Array) {
          this.$el.checked = this[model.prop].indexOf(this.$el.value) >= 0;
        } else {
          this.$el.checked = this[model.prop];
        }
      },
      _onModelEvent: function _onModelEvent(event) {
        var _event$target = event.target,
            value = _event$target.value,
            checked = _event$target.checked;
        var newValue;

        if (this[model.prop] instanceof Array) {
          // Is Array
          var index = this[model.prop].indexOf(value);
          var included = index >= 0;

          if (included && !checked) {
            newValue = [].concat(_toConsumableArray(this[model.prop].slice(0, index)), _toConsumableArray(this[model.prop].slice(index + 1, this[model.prop].length)));
          }

          if (!included && checked) {
            newValue = [].concat(_toConsumableArray(this[model.prop]), [value]);
          }
        } else {
          // Is Boolean
          newValue = checked;
        } // Emit if value changed


        newValue !== undefined && this.$emit(model.event, newValue);
      }
    }
  }; // Radio input

  var modelRadio = {
    mixins: [modelInput],
    props: _defineProperty({}, model.event, {
      type: String,
      "default": 'change'
    }),
    methods: {
      _updateValue: function _updateValue() {
        this.$el.checked = this[model.prop] === this.$el.value;
      },
      _onModelEvent: function _onModelEvent(event) {
        var _event$target2 = event.target,
            value = _event$target2.value,
            checked = _event$target2.checked;
        checked && this.$emit(model.event, value);
      }
    }
  };

  //

  var script$K = {
    name: 'v-ons-toolbar',
    mixins: [deriveEvents, hidable, modifier]
  };

  /* script */
              const __vue_script__$K = script$K;
              
  /* template */
  var __vue_render__$K = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-toolbar',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$K = [];

    /* style */
    const __vue_inject_styles__$K = undefined;
    /* scoped */
    const __vue_scope_id__$K = undefined;
    /* functional template */
    const __vue_is_functional_template__$K = false;
    /* component normalizer */
    function __vue_normalize__$K(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsToolbar.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsToolbar = __vue_normalize__$K(
      { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
      __vue_inject_styles__$K,
      __vue_script__$K,
      __vue_scope_id__$K,
      __vue_is_functional_template__$K);

  //

  var script$J = {
    name: 'v-ons-bottom-toolbar',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$J = script$J;
              
  /* template */
  var __vue_render__$J = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-bottom-toolbar',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$J = [];

    /* style */
    const __vue_inject_styles__$J = undefined;
    /* scoped */
    const __vue_scope_id__$J = undefined;
    /* functional template */
    const __vue_is_functional_template__$J = false;
    /* component normalizer */
    function __vue_normalize__$J(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsBottomToolbar.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsBottomToolbar = __vue_normalize__$J(
      { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
      __vue_inject_styles__$J,
      __vue_script__$J,
      __vue_scope_id__$J,
      __vue_is_functional_template__$J);

  //

  var script$I = {
    name: 'v-ons-toolbar-button',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$I = script$I;
              
  /* template */
  var __vue_render__$I = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-toolbar-button',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$I = [];

    /* style */
    const __vue_inject_styles__$I = undefined;
    /* scoped */
    const __vue_scope_id__$I = undefined;
    /* functional template */
    const __vue_is_functional_template__$I = false;
    /* component normalizer */
    function __vue_normalize__$I(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsToolbarButton.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsToolbarButton = __vue_normalize__$I(
      { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
      __vue_inject_styles__$I,
      __vue_script__$I,
      __vue_scope_id__$I,
      __vue_is_functional_template__$I);

  //

  var script$H = {
    name: 'v-ons-alert-dialog-button',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$H = script$H;
              
  /* template */
  var __vue_render__$H = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-alert-dialog-button',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$H = [];

    /* style */
    const __vue_inject_styles__$H = undefined;
    /* scoped */
    const __vue_scope_id__$H = undefined;
    /* functional template */
    const __vue_is_functional_template__$H = false;
    /* component normalizer */
    function __vue_normalize__$H(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsAlertDialogButton.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsAlertDialogButton = __vue_normalize__$H(
      { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
      __vue_inject_styles__$H,
      __vue_script__$H,
      __vue_scope_id__$H,
      __vue_is_functional_template__$H);

  //

  var script$G = {
    name: 'v-ons-button',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$G = script$G;
              
  /* template */
  var __vue_render__$G = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-button',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$G = [];

    /* style */
    const __vue_inject_styles__$G = undefined;
    /* scoped */
    const __vue_scope_id__$G = undefined;
    /* functional template */
    const __vue_is_functional_template__$G = false;
    /* component normalizer */
    function __vue_normalize__$G(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsButton.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsButton = __vue_normalize__$G(
      { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
      __vue_inject_styles__$G,
      __vue_script__$G,
      __vue_scope_id__$G,
      __vue_is_functional_template__$G);

  //

  var script$F = {
    name: 'v-ons-icon',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$F = script$F;
              
  /* template */
  var __vue_render__$F = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-icon',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$F = [];

    /* style */
    const __vue_inject_styles__$F = undefined;
    /* scoped */
    const __vue_scope_id__$F = undefined;
    /* functional template */
    const __vue_is_functional_template__$F = false;
    /* component normalizer */
    function __vue_normalize__$F(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsIcon.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsIcon = __vue_normalize__$F(
      { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
      __vue_inject_styles__$F,
      __vue_script__$F,
      __vue_scope_id__$F,
      __vue_is_functional_template__$F);

  //

  var script$E = {
    name: 'v-ons-card',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$E = script$E;
              
  /* template */
  var __vue_render__$E = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-card',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$E = [];

    /* style */
    const __vue_inject_styles__$E = undefined;
    /* scoped */
    const __vue_scope_id__$E = undefined;
    /* functional template */
    const __vue_is_functional_template__$E = false;
    /* component normalizer */
    function __vue_normalize__$E(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsCard.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsCard = __vue_normalize__$E(
      { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
      __vue_inject_styles__$E,
      __vue_script__$E,
      __vue_scope_id__$E,
      __vue_is_functional_template__$E);

  //

  var script$D = {
    name: 'v-ons-list',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$D = script$D;
              
  /* template */
  var __vue_render__$D = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-list',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$D = [];

    /* style */
    const __vue_inject_styles__$D = undefined;
    /* scoped */
    const __vue_scope_id__$D = undefined;
    /* functional template */
    const __vue_is_functional_template__$D = false;
    /* component normalizer */
    function __vue_normalize__$D(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsList.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsList = __vue_normalize__$D(
      { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
      __vue_inject_styles__$D,
      __vue_script__$D,
      __vue_scope_id__$D,
      __vue_is_functional_template__$D);

  //

  var script$C = {
    name: 'v-ons-list-item',
    mixins: [deriveEvents, modifier],
    methods: {
      onExpand() {
        this.$emit('update:expanded', this.$el.expanded);
      }
    }
  };

  /* script */
              const __vue_script__$C = script$C;
              
  /* template */
  var __vue_render__$C = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-list-item',_vm._g({attrs:{"modifier":_vm.normalizedModifier},on:{"expand":_vm.onExpand}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$C = [];

    /* style */
    const __vue_inject_styles__$C = undefined;
    /* scoped */
    const __vue_scope_id__$C = undefined;
    /* functional template */
    const __vue_is_functional_template__$C = false;
    /* component normalizer */
    function __vue_normalize__$C(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsListItem.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsListItem = __vue_normalize__$C(
      { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
      __vue_inject_styles__$C,
      __vue_script__$C,
      __vue_scope_id__$C,
      __vue_is_functional_template__$C);

  //

  var script$B = {
    name: 'v-ons-list-title',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$B = script$B;
              
  /* template */
  var __vue_render__$B = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-list-title',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$B = [];

    /* style */
    const __vue_inject_styles__$B = undefined;
    /* scoped */
    const __vue_scope_id__$B = undefined;
    /* functional template */
    const __vue_is_functional_template__$B = false;
    /* component normalizer */
    function __vue_normalize__$B(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsListTitle.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsListTitle = __vue_normalize__$B(
      { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
      __vue_inject_styles__$B,
      __vue_script__$B,
      __vue_scope_id__$B,
      __vue_is_functional_template__$B);

  //

  var script$A = {
    name: 'v-ons-list-header',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$A = script$A;
              
  /* template */
  var __vue_render__$A = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-list-header',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$A = [];

    /* style */
    const __vue_inject_styles__$A = undefined;
    /* scoped */
    const __vue_scope_id__$A = undefined;
    /* functional template */
    const __vue_is_functional_template__$A = false;
    /* component normalizer */
    function __vue_normalize__$A(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsListHeader.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsListHeader = __vue_normalize__$A(
      { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
      __vue_inject_styles__$A,
      __vue_script__$A,
      __vue_scope_id__$A,
      __vue_is_functional_template__$A);

  //

  var script$z = {
    name: 'v-ons-ripple',
    mixins: [deriveEvents]
  };

  /* script */
              const __vue_script__$z = script$z;
              
  /* template */
  var __vue_render__$z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-ripple',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$z = [];

    /* style */
    const __vue_inject_styles__$z = undefined;
    /* scoped */
    const __vue_scope_id__$z = undefined;
    /* functional template */
    const __vue_is_functional_template__$z = false;
    /* component normalizer */
    function __vue_normalize__$z(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsRipple.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsRipple = __vue_normalize__$z(
      { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
      __vue_inject_styles__$z,
      __vue_script__$z,
      __vue_scope_id__$z,
      __vue_is_functional_template__$z);

  //

  var script$y = {
    name: 'v-ons-row',
    mixins: [deriveEvents]
  };

  /* script */
              const __vue_script__$y = script$y;
              
  /* template */
  var __vue_render__$y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-row',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$y = [];

    /* style */
    const __vue_inject_styles__$y = undefined;
    /* scoped */
    const __vue_scope_id__$y = undefined;
    /* functional template */
    const __vue_is_functional_template__$y = false;
    /* component normalizer */
    function __vue_normalize__$y(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsRow.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsRow = __vue_normalize__$y(
      { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
      __vue_inject_styles__$y,
      __vue_script__$y,
      __vue_scope_id__$y,
      __vue_is_functional_template__$y);

  //

  var script$x = {
    name: 'v-ons-col',
    mixins: [deriveEvents]
  };

  /* script */
              const __vue_script__$x = script$x;
              
  /* template */
  var __vue_render__$x = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-col',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$x = [];

    /* style */
    const __vue_inject_styles__$x = undefined;
    /* scoped */
    const __vue_scope_id__$x = undefined;
    /* functional template */
    const __vue_is_functional_template__$x = false;
    /* component normalizer */
    function __vue_normalize__$x(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsCol.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsCol = __vue_normalize__$x(
      { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
      __vue_inject_styles__$x,
      __vue_script__$x,
      __vue_scope_id__$x,
      __vue_is_functional_template__$x);

  //

  var script$w = {
    name: 'v-ons-progress-bar',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$w = script$w;
              
  /* template */
  var __vue_render__$w = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-progress-bar',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$w = [];

    /* style */
    const __vue_inject_styles__$w = undefined;
    /* scoped */
    const __vue_scope_id__$w = undefined;
    /* functional template */
    const __vue_is_functional_template__$w = false;
    /* component normalizer */
    function __vue_normalize__$w(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsProgressBar.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsProgressBar = __vue_normalize__$w(
      { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
      __vue_inject_styles__$w,
      __vue_script__$w,
      __vue_scope_id__$w,
      __vue_is_functional_template__$w);

  //

  var script$v = {
    name: 'v-ons-progress-circular',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$v = script$v;
              
  /* template */
  var __vue_render__$v = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-progress-circular',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$v = [];

    /* style */
    const __vue_inject_styles__$v = undefined;
    /* scoped */
    const __vue_scope_id__$v = undefined;
    /* functional template */
    const __vue_is_functional_template__$v = false;
    /* component normalizer */
    function __vue_normalize__$v(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsProgressCircular.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsProgressCircular = __vue_normalize__$v(
      { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
      __vue_inject_styles__$v,
      __vue_script__$v,
      __vue_scope_id__$v,
      __vue_is_functional_template__$v);

  //

  var script$u = {
    name: 'v-ons-carousel-item',
    mixins: [deriveEvents]
  };

  /* script */
              const __vue_script__$u = script$u;
              
  /* template */
  var __vue_render__$u = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-carousel-item',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$u = [];

    /* style */
    const __vue_inject_styles__$u = undefined;
    /* scoped */
    const __vue_scope_id__$u = undefined;
    /* functional template */
    const __vue_is_functional_template__$u = false;
    /* component normalizer */
    function __vue_normalize__$u(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsCarouselItem.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsCarouselItem = __vue_normalize__$u(
      { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
      __vue_inject_styles__$u,
      __vue_script__$u,
      __vue_scope_id__$u,
      __vue_is_functional_template__$u);

  //

  var script$t = {
    name: 'v-ons-splitter-mask',
    mixins: [deriveEvents]
  };

  /* script */
              const __vue_script__$t = script$t;
              
  /* template */
  var __vue_render__$t = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-splitter-mask',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$t = [];

    /* style */
    const __vue_inject_styles__$t = undefined;
    /* scoped */
    const __vue_scope_id__$t = undefined;
    /* functional template */
    const __vue_is_functional_template__$t = false;
    /* component normalizer */
    function __vue_normalize__$t(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSplitterMask.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSplitterMask = __vue_normalize__$t(
      { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
      __vue_inject_styles__$t,
      __vue_script__$t,
      __vue_scope_id__$t,
      __vue_is_functional_template__$t);

  //

  var script$s = {
    name: 'v-ons-splitter-content',
    mixins: [deriveEvents]
  };

  /* script */
              const __vue_script__$s = script$s;
              
  /* template */
  var __vue_render__$s = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-splitter-content',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$s = [];

    /* style */
    const __vue_inject_styles__$s = undefined;
    /* scoped */
    const __vue_scope_id__$s = undefined;
    /* functional template */
    const __vue_is_functional_template__$s = false;
    /* component normalizer */
    function __vue_normalize__$s(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSplitterContent.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSplitterContent = __vue_normalize__$s(
      { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
      __vue_inject_styles__$s,
      __vue_script__$s,
      __vue_scope_id__$s,
      __vue_is_functional_template__$s);

  //

  var script$r = {
    name: 'v-ons-splitter',
    mixins: [deriveEvents, selfProvider, deriveDBB]
  };

  /* script */
              const __vue_script__$r = script$r;
              
  /* template */
  var __vue_render__$r = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-splitter',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$r = [];

    /* style */
    const __vue_inject_styles__$r = undefined;
    /* scoped */
    const __vue_scope_id__$r = undefined;
    /* functional template */
    const __vue_is_functional_template__$r = false;
    /* component normalizer */
    function __vue_normalize__$r(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSplitter.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSplitter = __vue_normalize__$r(
      { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
      __vue_inject_styles__$r,
      __vue_script__$r,
      __vue_scope_id__$r,
      __vue_is_functional_template__$r);

  //

  var script$q = {
    name: 'v-ons-switch',
    mixins: [deriveEvents, modelCheckbox, modifier]
  };

  /* script */
              const __vue_script__$q = script$q;
              
  /* template */
  var __vue_render__$q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-switch',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$q = [];

    /* style */
    const __vue_inject_styles__$q = undefined;
    /* scoped */
    const __vue_scope_id__$q = undefined;
    /* functional template */
    const __vue_is_functional_template__$q = false;
    /* component normalizer */
    function __vue_normalize__$q(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSwitch.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSwitch = __vue_normalize__$q(
      { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
      __vue_inject_styles__$q,
      __vue_script__$q,
      __vue_scope_id__$q,
      __vue_is_functional_template__$q);

  //

  var script$p = {
    name: 'v-ons-checkbox',
    mixins: [deriveEvents, modelCheckbox, modifier]
  };

  /* script */
              const __vue_script__$p = script$p;
              
  /* template */
  var __vue_render__$p = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-checkbox',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$p = [];

    /* style */
    const __vue_inject_styles__$p = undefined;
    /* scoped */
    const __vue_scope_id__$p = undefined;
    /* functional template */
    const __vue_is_functional_template__$p = false;
    /* component normalizer */
    function __vue_normalize__$p(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsCheckbox.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsCheckbox = __vue_normalize__$p(
      { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
      __vue_inject_styles__$p,
      __vue_script__$p,
      __vue_scope_id__$p,
      __vue_is_functional_template__$p);

  //

  var script$o = {
    name: 'v-ons-input',
    mixins: [deriveEvents, modelInput, modifier]
  };

  /* script */
              const __vue_script__$o = script$o;
              
  /* template */
  var __vue_render__$o = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-input',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$o = [];

    /* style */
    const __vue_inject_styles__$o = undefined;
    /* scoped */
    const __vue_scope_id__$o = undefined;
    /* functional template */
    const __vue_is_functional_template__$o = false;
    /* component normalizer */
    function __vue_normalize__$o(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsInput.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsInput = __vue_normalize__$o(
      { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
      __vue_inject_styles__$o,
      __vue_script__$o,
      __vue_scope_id__$o,
      __vue_is_functional_template__$o);

  //

  var script$n = {
    name: 'v-ons-search-input',
    mixins: [deriveEvents, modelInput, modifier]
  };

  /* script */
              const __vue_script__$n = script$n;
              
  /* template */
  var __vue_render__$n = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-search-input',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$n = [];

    /* style */
    const __vue_inject_styles__$n = undefined;
    /* scoped */
    const __vue_scope_id__$n = undefined;
    /* functional template */
    const __vue_is_functional_template__$n = false;
    /* component normalizer */
    function __vue_normalize__$n(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSearchInput.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSearchInput = __vue_normalize__$n(
      { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
      __vue_inject_styles__$n,
      __vue_script__$n,
      __vue_scope_id__$n,
      __vue_is_functional_template__$n);

  //

  var script$m = {
    name: 'v-ons-range',
    mixins: [deriveEvents, modelInputNumber, modifier]
  };

  /* script */
              const __vue_script__$m = script$m;
              
  /* template */
  var __vue_render__$m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-range',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$m = [];

    /* style */
    const __vue_inject_styles__$m = undefined;
    /* scoped */
    const __vue_scope_id__$m = undefined;
    /* functional template */
    const __vue_is_functional_template__$m = false;
    /* component normalizer */
    function __vue_normalize__$m(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsRange.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsRange = __vue_normalize__$m(
      { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
      __vue_inject_styles__$m,
      __vue_script__$m,
      __vue_scope_id__$m,
      __vue_is_functional_template__$m);

  //

  var script$l = {
    name: 'v-ons-radio',
    mixins: [deriveEvents, modelRadio, modifier]
  };

  /* script */
              const __vue_script__$l = script$l;
              
  /* template */
  var __vue_render__$l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-radio',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$l = [];

    /* style */
    const __vue_inject_styles__$l = undefined;
    /* scoped */
    const __vue_scope_id__$l = undefined;
    /* functional template */
    const __vue_is_functional_template__$l = false;
    /* component normalizer */
    function __vue_normalize__$l(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsRadio.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsRadio = __vue_normalize__$l(
      { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
      __vue_inject_styles__$l,
      __vue_script__$l,
      __vue_scope_id__$l,
      __vue_is_functional_template__$l);

  //

  var script$k = {
    name: 'v-ons-fab',
    mixins: [deriveEvents, hidable, modifier]
  };

  /* script */
              const __vue_script__$k = script$k;
              
  /* template */
  var __vue_render__$k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-fab',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$k = [];

    /* style */
    const __vue_inject_styles__$k = undefined;
    /* scoped */
    const __vue_scope_id__$k = undefined;
    /* functional template */
    const __vue_is_functional_template__$k = false;
    /* component normalizer */
    function __vue_normalize__$k(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsFab.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsFab = __vue_normalize__$k(
      { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
      __vue_inject_styles__$k,
      __vue_script__$k,
      __vue_scope_id__$k,
      __vue_is_functional_template__$k);

  //

  var script$j = {
    name: 'v-ons-speed-dial-item',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$j = script$j;
              
  /* template */
  var __vue_render__$j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-speed-dial-item',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$j = [];

    /* style */
    const __vue_inject_styles__$j = undefined;
    /* scoped */
    const __vue_scope_id__$j = undefined;
    /* functional template */
    const __vue_is_functional_template__$j = false;
    /* component normalizer */
    function __vue_normalize__$j(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSpeedDialItem.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSpeedDialItem = __vue_normalize__$j(
      { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
      __vue_inject_styles__$j,
      __vue_script__$j,
      __vue_scope_id__$j,
      __vue_is_functional_template__$j);

  //

  var script$i = {
    name: 'v-ons-dialog',
    mixins: [deriveEvents, hasOptions, dialogCancel, deriveDBB, portal, modifier]
  };

  /* script */
              const __vue_script__$i = script$i;
              
  /* template */
  var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-dialog',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$i = [];

    /* style */
    const __vue_inject_styles__$i = undefined;
    /* scoped */
    const __vue_scope_id__$i = undefined;
    /* functional template */
    const __vue_is_functional_template__$i = false;
    /* component normalizer */
    function __vue_normalize__$i(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsDialog.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsDialog = __vue_normalize__$i(
      { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
      __vue_inject_styles__$i,
      __vue_script__$i,
      __vue_scope_id__$i,
      __vue_is_functional_template__$i);

  //

  var script$h = {
    name: 'v-ons-action-sheet',
    mixins: [deriveEvents, hasOptions, dialogCancel, deriveDBB, portal, modifier]
  };

  /* script */
              const __vue_script__$h = script$h;
              
  /* template */
  var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-action-sheet',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$h = [];

    /* style */
    const __vue_inject_styles__$h = undefined;
    /* scoped */
    const __vue_scope_id__$h = undefined;
    /* functional template */
    const __vue_is_functional_template__$h = false;
    /* component normalizer */
    function __vue_normalize__$h(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsActionSheet.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsActionSheet = __vue_normalize__$h(
      { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
      __vue_inject_styles__$h,
      __vue_script__$h,
      __vue_scope_id__$h,
      __vue_is_functional_template__$h);

  //

  var script$g = {
    name: 'v-ons-action-sheet-button',
    mixins: [deriveEvents, modifier]
  };

  /* script */
              const __vue_script__$g = script$g;
              
  /* template */
  var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-action-sheet-button',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$g = [];

    /* style */
    const __vue_inject_styles__$g = undefined;
    /* scoped */
    const __vue_scope_id__$g = undefined;
    /* functional template */
    const __vue_is_functional_template__$g = false;
    /* component normalizer */
    function __vue_normalize__$g(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsActionSheetButton.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsActionSheetButton = __vue_normalize__$g(
      { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
      __vue_inject_styles__$g,
      __vue_script__$g,
      __vue_scope_id__$g,
      __vue_is_functional_template__$g);

  //

  var script$f = {
    name: 'v-ons-modal',
    mixins: [deriveEvents, hidable, hasOptions, deriveDBB, portal, modifier]
  };

  /* script */
              const __vue_script__$f = script$f;
              
  /* template */
  var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-modal',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$f = [];

    /* style */
    const __vue_inject_styles__$f = undefined;
    /* scoped */
    const __vue_scope_id__$f = undefined;
    /* functional template */
    const __vue_is_functional_template__$f = false;
    /* component normalizer */
    function __vue_normalize__$f(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsModal.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsModal = __vue_normalize__$f(
      { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
      __vue_inject_styles__$f,
      __vue_script__$f,
      __vue_scope_id__$f,
      __vue_is_functional_template__$f);

  //

  var script$e = {
    name: 'v-ons-toast',
    mixins: [deriveEvents, hasOptions, deriveDBB, portal, modifier]
  };

  /* script */
              const __vue_script__$e = script$e;
              
  /* template */
  var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-toast',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$e = [];

    /* style */
    const __vue_inject_styles__$e = undefined;
    /* scoped */
    const __vue_scope_id__$e = undefined;
    /* functional template */
    const __vue_is_functional_template__$e = false;
    /* component normalizer */
    function __vue_normalize__$e(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsToast.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsToast = __vue_normalize__$e(
      { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
      __vue_inject_styles__$e,
      __vue_script__$e,
      __vue_scope_id__$e,
      __vue_is_functional_template__$e);

  //

  var script$d = {
    name: 'v-ons-popover',
    mixins: [hidable, hasOptions, dialogCancel, deriveEvents, deriveDBB, portal],

    props: {
      target: {
        validator(value) {
          return value._isVue || typeof value === 'string' || value instanceof Event || value instanceof HTMLElement;
        }
      }
    },

    computed: {
      normalizedTarget() {
        if (this.target && this.target._isVue) {
          return this.target.$el;
        }
        return this.target;
      },
      normalizedOptions() {
        if (this.target) {
          return {
            target: this.normalizedTarget,
            ...this.options
          };
        }
        return this.options;
      }
    }
  };

  /* script */
              const __vue_script__$d = script$d;
              
  /* template */
  var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-popover',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$d = [];

    /* style */
    const __vue_inject_styles__$d = undefined;
    /* scoped */
    const __vue_scope_id__$d = undefined;
    /* functional template */
    const __vue_is_functional_template__$d = false;
    /* component normalizer */
    function __vue_normalize__$d(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsPopover.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsPopover = __vue_normalize__$d(
      { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
      __vue_inject_styles__$d,
      __vue_script__$d,
      __vue_scope_id__$d,
      __vue_is_functional_template__$d);

  //

  var script$c = {
    name: 'v-ons-alert-dialog',
    mixins: [hasOptions, dialogCancel, deriveEvents, deriveDBB, portal, modifier],

    props: {
      title: {
        type: String
      },
      footer: {
        type: Object,
        validator(value) {
          return Object.keys(value).every(key => value[key] instanceof Function);
        }
      }
    }
  };

  /* script */
              const __vue_script__$c = script$c;
              
  /* template */
  var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-alert-dialog',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.unrecognizedListeners),[_c('div',{staticClass:"alert-dialog-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"alert-dialog-content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"alert-dialog-footer"},[_vm._t("footer",function(){return _vm._l((_vm.footer),function(handler,key){return _c('ons-alert-dialog-button',{key:key,on:{"click":handler}},[_vm._v(_vm._s(key))])})})],2)])};
  var __vue_staticRenderFns__$c = [];

    /* style */
    const __vue_inject_styles__$c = undefined;
    /* scoped */
    const __vue_scope_id__$c = undefined;
    /* functional template */
    const __vue_is_functional_template__$c = false;
    /* component normalizer */
    function __vue_normalize__$c(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsAlertDialog.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsAlertDialog = __vue_normalize__$c(
      { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
      __vue_inject_styles__$c,
      __vue_script__$c,
      __vue_scope_id__$c,
      __vue_is_functional_template__$c);

  //

  var script$b = {
    name: 'v-ons-speed-dial',
    mixins: [deriveEvents, hidable],

    props: {
      open: {
        type: Boolean,
        default: undefined
      }
    },

    methods: {
      _shouldUpdate() {
        return this.open !== undefined && this.open !== this.$el.isOpen();
      },
      _updateToggle() {
        this._shouldUpdate() && this.$el[this.open ? 'showItems' : 'hideItems'].call(this.$el);
      }
    },

    watch: {
      open() {
        this._updateToggle();
      }
    },

    mounted() {
      this.$on(['open', 'close'], () => this._shouldUpdate() && this.$emit('update:open', this.$el.isOpen()));

      this._updateToggle();
    }
  };

  /* script */
              const __vue_script__$b = script$b;
              
  /* template */
  var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-speed-dial',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$b = [];

    /* style */
    const __vue_inject_styles__$b = undefined;
    /* scoped */
    const __vue_scope_id__$b = undefined;
    /* functional template */
    const __vue_is_functional_template__$b = false;
    /* component normalizer */
    function __vue_normalize__$b(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSpeedDial.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSpeedDial = __vue_normalize__$b(
      { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
      __vue_inject_styles__$b,
      __vue_script__$b,
      __vue_scope_id__$b,
      __vue_is_functional_template__$b);

  //

  var script$a = {
    name: 'v-ons-carousel',
    mixins: [hasOptions, deriveEvents],

    props: {
      index: {
        type: Number
      }
    },

    watch: {
      index() {
        if (this.index !== this.$el.getActiveIndex()) {
          this.$el.setActiveIndex(this.index, this.options);
        }
      }
    }
  };

  /* script */
              const __vue_script__$a = script$a;
              
  /* template */
  var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-carousel',_vm._g({attrs:{"initial-index":_vm.index},on:{"postchange":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('update:index', $event.activeIndex)}}},_vm.unrecognizedListeners),[_c('div',[_vm._t("default")],2),_vm._v(" "),_c('div')])};
  var __vue_staticRenderFns__$a = [];

    /* style */
    const __vue_inject_styles__$a = undefined;
    /* scoped */
    const __vue_scope_id__$a = undefined;
    /* functional template */
    const __vue_is_functional_template__$a = false;
    /* component normalizer */
    function __vue_normalize__$a(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsCarousel.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsCarousel = __vue_normalize__$a(
      { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
      __vue_inject_styles__$a,
      __vue_script__$a,
      __vue_scope_id__$a,
      __vue_is_functional_template__$a);

  //

  var script$9 = {
    name: 'v-ons-tab',
    inject: ['tabbar'],

    props: {
      page: { },
      props: { },
      active: {
        type: Boolean
      }
    },

    methods: {
      action() {
        let runDefault = true;
        this.$emit('click', { preventDefault: () => runDefault = false });

        if (runDefault) {
          this.tabbar.$el.setActiveTab(this.$el.index, { reject: false, ...this.tabbar.options });
        }
      }
    },

    watch: {
      active() {
        this.$el.setActive(this.active);
      }
    }
  };

  /* script */
              const __vue_script__$9 = script$9;
              
  /* template */
  var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-tab',{attrs:{"active":_vm.active},on:{"click":function($event){$event.preventDefault();return _vm.action.apply(null, arguments)}}})};
  var __vue_staticRenderFns__$9 = [];

    /* style */
    const __vue_inject_styles__$9 = undefined;
    /* scoped */
    const __vue_scope_id__$9 = undefined;
    /* functional template */
    const __vue_is_functional_template__$9 = false;
    /* component normalizer */
    function __vue_normalize__$9(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsTab.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsTab = __vue_normalize__$9(
      { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
      __vue_inject_styles__$9,
      __vue_script__$9,
      __vue_scope_id__$9,
      __vue_is_functional_template__$9);

  //

  var script$8 = {
    name: 'v-ons-tabbar',
    mixins: [deriveEvents, hasOptions, hidable, selfProvider, modifier],

    props: {
      index: {
        type: Number
      },
      tabs: {
        type: Array,
        validator(value) {
          return value.every(tab => ['icon', 'label', 'page'].some(prop => !!Object.getOwnPropertyDescriptor(tab, prop)));
        }
      },
      tabbarStyle: {
        type: null
      }
    },

    methods: {
      _tabKey(tab) {
        return tab.key || tab.label || tab.icon;
      }
    },

    watch: {
      index() {
        if (this.index !== this.$el.getActiveTabIndex()) {
          this.$el.setActiveTab(this.index, { reject: false, ...this.options });
        }
      }
    }
  };

  /* script */
              const __vue_script__$8 = script$8;
              
  /* template */
  var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-tabbar',_vm._g({attrs:{"activeIndex":_vm.index,"modifier":_vm.normalizedModifier},on:{"prechange":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$nextTick(function () { return !$event.detail.canceled && _vm.$emit('update:index', $event.index); });}}},_vm.unrecognizedListeners),[_c('div',{staticClass:"tabbar__content"},[_c('div',[_vm._t("pages",function(){return _vm._l((_vm.tabs),function(tab){return _c(tab.page,_vm._g(_vm._b({key:(tab.page.key || tab.page.name || _vm._tabKey(tab)),tag:"component"},'component',tab.props,false),_vm.unrecognizedListeners))})})],2),_vm._v(" "),_c('div')]),_vm._v(" "),_c('div',{staticClass:"tabbar",style:(_vm.tabbarStyle)},[_vm._t("default",function(){return _vm._l((_vm.tabs),function(tab){return _c('v-ons-tab',_vm._b({key:_vm._tabKey(tab)},'v-ons-tab',tab,false))})}),_vm._v(" "),_c('div',{staticClass:"tabbar__border"})],2)])};
  var __vue_staticRenderFns__$8 = [];

    /* style */
    const __vue_inject_styles__$8 = undefined;
    /* scoped */
    const __vue_scope_id__$8 = undefined;
    /* functional template */
    const __vue_is_functional_template__$8 = false;
    /* component normalizer */
    function __vue_normalize__$8(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsTabbar.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsTabbar = __vue_normalize__$8(
      { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
      __vue_inject_styles__$8,
      __vue_script__$8,
      __vue_scope_id__$8,
      __vue_is_functional_template__$8);

  //

  var script$7 = {
    name: 'v-ons-back-button',
    inject: ['navigator'],
    mixins: [modifier],

    methods: {
      action() {
        let runDefault = true;
        this.$emit('click', { preventDefault: () => runDefault = false });

        if (runDefault && this.navigator.pageStack.length > 1) {
          this.navigator.popPage();
        }
      }
    }
  };

  /* script */
              const __vue_script__$7 = script$7;
              
  /* template */
  var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-back-button',{on:{"click":function($event){$event.preventDefault();return _vm.action.apply(null, arguments)}}},[_vm._t("default")],2)};
  var __vue_staticRenderFns__$7 = [];

    /* style */
    const __vue_inject_styles__$7 = undefined;
    /* scoped */
    const __vue_scope_id__$7 = undefined;
    /* functional template */
    const __vue_is_functional_template__$7 = false;
    /* component normalizer */
    function __vue_normalize__$7(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsBackButton.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsBackButton = __vue_normalize__$7(
      { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
      __vue_inject_styles__$7,
      __vue_script__$7,
      __vue_scope_id__$7,
      __vue_is_functional_template__$7);

  //

  var script$6 = {
    name: 'v-ons-navigator',
    mixins: [hasOptions, selfProvider, deriveEvents, deriveDBB],

    props: {
      pageStack: {
        type: Array,
        required: true
      },
      popPage: {
        type: Function,
        default() {
          this.pageStack.pop();
        }
      }
    },

    methods: {
      isReady() {
        if (this.hasOwnProperty('_ready') && this._ready instanceof Promise) {
          return this._ready;
        }
        return Promise.resolve();
      },
      onDeviceBackButton(event) {
        if (this.pageStack.length > 1) {
          this.popPage();
        } else {
          event.callParentHandler();
        }
      },
      _findScrollPage(page) {
        const nextPage = page._contentElement.children.length === 1
          && this.$ons._ons._util.getTopPage(page._contentElement.children[0]);
        return nextPage ? this._findScrollPage(nextPage) : page;
      },
      _eachPage(start, end, cb) {
        for (let i = start; i < end; i++) {
          cb(this.$children[i].$el);
        }
      },
      _reattachPage(pageElement, position = null, restoreScroll) {
        this.$el.insertBefore(pageElement, position);
        restoreScroll instanceof Function && restoreScroll();
        pageElement._isShown = true;
      },
      _redetachPage(pageElement) {
        pageElement._destroy();
        return Promise.resolve();
      },
      _animate({ lastLength, currentLength, lastTopPage, currentTopPage, restoreScroll }) {
        const pushedOptions = this.pageStack[this.pageStack.length - 1].onsNavigatorOptions
          || currentTopPage.__vue__.onsNavigatorOptions
          || {};

        // Push
        if (currentLength > lastLength) {
          let isReattached = false;
          if (lastTopPage.parentElement !== this.$el) {
            this._reattachPage(lastTopPage, this.$el.children[lastLength - 1], restoreScroll);
            isReattached = true;
            lastLength--;
          }

          this._eachPage(lastLength, currentLength, el => { el.style.visibility = 'hidden'; });
          this._eachPage(lastLength, currentLength - 1, el => { el.pushedOptions = pushedOptions; });

          return this.$el._pushPage({ ...pushedOptions, leavePage: lastTopPage })
            .then(() => {
              setImmediate(() => {
                this._eachPage(lastLength, currentLength, el => { el.style.visibility = ''; });
                this._eachPage(lastLength - 1, currentLength - 1, el => { el.style.display = 'none'; });
              });

              if (isReattached) {
                this._redetachPage(lastTopPage);
              }
            }, () => { // push failed or was canceled
              this._canceled = true;
              this.pageStack.pop();
            });
        }

        // Pop
        if (currentLength < lastLength) {
          this._reattachPage(lastTopPage, null, restoreScroll);
          return this.$el._popPage({ }, () => this._redetachPage(lastTopPage));
        }

        // Replace page
        currentTopPage.style.visibility = 'hidden';
        this._reattachPage(lastTopPage, currentTopPage, restoreScroll);
        return this.$el._pushPage({ ...pushedOptions, _replacePage: true })
          .then(() => this._redetachPage(lastTopPage));
      },
      _checkSwipe(event) {
        if (this.$el.hasAttribute('swipeable') &&
          event.leavePage !== this.$el.lastChild && event.leavePage === this.$children[this.$children.length - 1].$el
        ) {
          this.popPage();
        }
      }
    },

    watch: {
      pageStack(after, before) {
        if (this.$el.hasAttribute('swipeable') && this.$children.length !== this.$el.children.length) {
          return;
        }

        // watcher triggered by undoing a canceled push or pop
        if (this._canceled) {
          this._canceled = null;
          return;
        }

        const propWasMutated = after === before; // Can be mutated or replaced
        const lastTopPage = this.$children[this.$children.length - 1].$el;
        const scrollElement = this._findScrollPage(lastTopPage);
        const scrollValue = scrollElement.scrollTop || 0;

        this._pageStackUpdate = {
          lastTopPage,
          lastLength: propWasMutated ? this.$children.length : before.length,
          currentLength: !propWasMutated && after.length,
          restoreScroll: () => scrollElement.scrollTop = scrollValue
        };

        // this.$nextTick(() => { }); // Waits too long, updated() hook is faster and prevents flickerings
      }
    },

    updated() {
      if (this._pageStackUpdate) {
        let currentTopPage = this.$children[this.$children.length - 1].$el;
        let { lastTopPage, currentLength } = this._pageStackUpdate;
        const { lastLength, restoreScroll } = this._pageStackUpdate;
        currentLength = currentLength === false ? this.$children.length : currentLength;

        if (currentTopPage !== lastTopPage) {
          this._ready = this._animate({ lastLength, currentLength, lastTopPage, currentTopPage, restoreScroll });
        } else if (currentLength !== lastLength) {
          currentTopPage.updateBackButton(currentLength > 1);
        }

        lastTopPage = currentTopPage = this._pageStackUpdate = null;
      }
    }
  };

  /* script */
              const __vue_script__$6 = script$6;
              
  /* template */
  var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-navigator',_vm._g({domProps:{"options":_vm.options},on:{"postpop":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm._checkSwipe.apply(null, arguments)}}},_vm.unrecognizedListeners),[_vm._t("default",function(){return _vm._l((_vm.pageStack),function(page){return _c(page,_vm._g(_vm._b({key:page.key || page.name,tag:"component"},'component',page.onsNavigatorProps,false),_vm.unrecognizedListeners))})})],2)};
  var __vue_staticRenderFns__$6 = [];

    /* style */
    const __vue_inject_styles__$6 = undefined;
    /* scoped */
    const __vue_scope_id__$6 = undefined;
    /* functional template */
    const __vue_is_functional_template__$6 = false;
    /* component normalizer */
    function __vue_normalize__$6(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsNavigator.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsNavigator = __vue_normalize__$6(
      { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
      __vue_inject_styles__$6,
      __vue_script__$6,
      __vue_scope_id__$6,
      __vue_is_functional_template__$6);

  //

  var script$5 = {
    name: 'v-ons-splitter-side',
    mixins: [hasOptions, deriveEvents],

    props: {
      open: {
        type: Boolean,
        default: undefined
      }
    },

    methods: {
      action() {
        this._shouldUpdate() && this.$el[this.open ? 'open' : 'close'].call(this.$el, this.options).catch(() => {});
      },
      _shouldUpdate() {
        return this.open !== undefined && this.open !== this.$el.isOpen;
      }
    },

    watch: {
      open() {
        this.action();
      }
    },

    mounted() {
      this.$on(['postopen', 'postclose', 'modechange'], () => this._shouldUpdate() && this.$emit('update:open', this.$el.isOpen));

      this.action();
    }
  };

  /* script */
              const __vue_script__$5 = script$5;
              
  /* template */
  var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-splitter-side',_vm._g({},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$5 = [];

    /* style */
    const __vue_inject_styles__$5 = undefined;
    /* scoped */
    const __vue_scope_id__$5 = undefined;
    /* functional template */
    const __vue_is_functional_template__$5 = false;
    /* component normalizer */
    function __vue_normalize__$5(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSplitterSide.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSplitterSide = __vue_normalize__$5(
      { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
      __vue_inject_styles__$5,
      __vue_script__$5,
      __vue_scope_id__$5,
      __vue_is_functional_template__$5);

  //

  var script$4 = {
    name: 'v-ons-lazy-repeat',

    props: {
      renderItem: {
        type: Function,
        required: true,
        validator(value) {
          const component = value(0);
          if (component._isVue && !component._isMounted) {
            component.$destroy();
            return true;
          }
          return false;
        }
      },
      length: {
        type: Number,
        required: true
      },
      calculateItemHeight: {
        type: Function,
        default: undefined
      }
    },

    data() {
      return {
        provider: null
      };
    },

    methods: {
      _setup() {
        this.provider && this.provider.destroy();

        const delegate = new this.$ons._ons._internal.LazyRepeatDelegate({
          calculateItemHeight: this.calculateItemHeight,
          createItemContent: i => this.renderItem(i).$mount().$el,
          destroyItem: (i, { element }) => element.__vue__.$destroy(),
          countItems: () => this.length
        }, null);

        this.provider = new this.$ons._ons._internal.LazyRepeatProvider(this.$parent.$el, delegate);
      },
      refresh() {
        return this.provider.refresh();
      }
    },

    watch: {
      renderItem() {
        this._setup();
      },
      length() {
        this._setup();
      },
      calculateItemHeight() {
        this._setup();
      }
    },

    mounted() {
      this._setup();
      this.$vnode.context.$on('refresh', this.refresh);
    },

    beforeDestroy() {
      this.$vnode.context.$off('refresh', this.refresh);

      // This will destroy the provider once the rendered element
      // is detached (detachedCallback). Therefore, animations
      // have time to finish before elements start to disappear.
      // It cannot be set earlier in order to prevent accidental
      // destroys if this element is retached by something else.
      this.$el._lazyRepeatProvider = this.provider;
      this.provider = null;
    }
  };

  /* script */
              const __vue_script__$4 = script$4;
              
  /* template */
  var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-lazy-repeat')};
  var __vue_staticRenderFns__$4 = [];

    /* style */
    const __vue_inject_styles__$4 = undefined;
    /* scoped */
    const __vue_scope_id__$4 = undefined;
    /* functional template */
    const __vue_is_functional_template__$4 = false;
    /* component normalizer */
    function __vue_normalize__$4(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsLazyRepeat.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsLazyRepeat = __vue_normalize__$4(
      { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
      __vue_inject_styles__$4,
      __vue_script__$4,
      __vue_scope_id__$4,
      __vue_is_functional_template__$4);

  //

  var script$3 = {
    name: 'v-ons-select',
    mixins: [modifier],
    model: {
      prop: 'modelProp',
      event: 'modelEvent'
    },
    props: {
      modelProp: [Number, String],
      modelEvent: {
        type: String,
        default: 'input'
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.modelProp;
        },
        set(val) {
          this.$emit('modelEvent', val);
        }
      }
    }
  };

  /* script */
              const __vue_script__$3 = script$3;
              
  /* template */
  var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-select',_vm._g({attrs:{"modifier":_vm.normalizedModifier}},_vm.$listeners),[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedValue),expression:"selectedValue"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},[_vm._t("default")],2)])};
  var __vue_staticRenderFns__$3 = [];

    /* style */
    const __vue_inject_styles__$3 = undefined;
    /* scoped */
    const __vue_scope_id__$3 = undefined;
    /* functional template */
    const __vue_is_functional_template__$3 = false;
    /* component normalizer */
    function __vue_normalize__$3(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSelect.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSelect = __vue_normalize__$3(
      { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
      __vue_inject_styles__$3,
      __vue_script__$3,
      __vue_scope_id__$3,
      __vue_is_functional_template__$3);

  //

  var script$2 = {
    name: 'v-ons-segment',
    mixins: [deriveEvents],

    props: {
      index: {
        type: Number
      }
    },

    watch: {
      index() {
        if (this.index !== this.$el.getActiveButtonIndex()) {
          this.$el.setActiveButton(this.index, { reject: false });
        }
      }
    }
  };

  /* script */
              const __vue_script__$2 = script$2;
              
  /* template */
  var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-segment',{attrs:{"active-index":_vm.index},on:{"postchange":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('update:index', $event.index)}}},[_vm._t("default")],2)};
  var __vue_staticRenderFns__$2 = [];

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = false;
    /* component normalizer */
    function __vue_normalize__$2(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsSegment.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsSegment = __vue_normalize__$2(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2);

  //

  var script$1 = {
    name: 'v-ons-pull-hook',
    mixins: [deriveEvents],

    props: {
      action: {
        type: Function
      },
      onPull: {
        type: Function
      }
    }
  };

  /* script */
              const __vue_script__$1 = script$1;
              
  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-pull-hook',_vm._g({domProps:{"onAction":_vm.action,"onPull":_vm.onPull}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* component normalizer */
    function __vue_normalize__$1(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsPullHook.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsPullHook = __vue_normalize__$1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1);

  //

  var script = {
    name: 'v-ons-page',
    mixins: [deriveEvents, deriveDBB, modifier],

    props: {
      infiniteScroll: {
        type: Function
      }
    }
  };

  /* script */
              const __vue_script__ = script;
              
  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ons-page',_vm._g({attrs:{"modifier":_vm.normalizedModifier},domProps:{"onInfiniteScroll":_vm.infiniteScroll}},_vm.unrecognizedListeners),[_vm._t("default")],2)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* component normalizer */
    function __vue_normalize__(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "VOnsPage.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var VOnsPage = __vue_normalize__(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__);

  var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    VOnsToolbar: VOnsToolbar,
    VOnsBottomToolbar: VOnsBottomToolbar,
    VOnsToolbarButton: VOnsToolbarButton,
    VOnsAlertDialogButton: VOnsAlertDialogButton,
    VOnsButton: VOnsButton,
    VOnsIcon: VOnsIcon,
    VOnsCard: VOnsCard,
    VOnsList: VOnsList,
    VOnsListItem: VOnsListItem,
    VOnsListTitle: VOnsListTitle,
    VOnsListHeader: VOnsListHeader,
    VOnsRipple: VOnsRipple,
    VOnsRow: VOnsRow,
    VOnsCol: VOnsCol,
    VOnsProgressBar: VOnsProgressBar,
    VOnsProgressCircular: VOnsProgressCircular,
    VOnsCarouselItem: VOnsCarouselItem,
    VOnsSplitterMask: VOnsSplitterMask,
    VOnsSplitterContent: VOnsSplitterContent,
    VOnsSplitter: VOnsSplitter,
    VOnsSwitch: VOnsSwitch,
    VOnsCheckbox: VOnsCheckbox,
    VOnsInput: VOnsInput,
    VOnsSearchInput: VOnsSearchInput,
    VOnsRange: VOnsRange,
    VOnsRadio: VOnsRadio,
    VOnsFab: VOnsFab,
    VOnsSpeedDialItem: VOnsSpeedDialItem,
    VOnsDialog: VOnsDialog,
    VOnsActionSheet: VOnsActionSheet,
    VOnsActionSheetButton: VOnsActionSheetButton,
    VOnsModal: VOnsModal,
    VOnsToast: VOnsToast,
    VOnsPopover: VOnsPopover,
    VOnsAlertDialog: VOnsAlertDialog,
    VOnsSpeedDial: VOnsSpeedDial,
    VOnsCarousel: VOnsCarousel,
    VOnsTab: VOnsTab,
    VOnsTabbar: VOnsTabbar,
    VOnsBackButton: VOnsBackButton,
    VOnsNavigator: VOnsNavigator,
    VOnsSplitterSide: VOnsSplitterSide,
    VOnsLazyRepeat: VOnsLazyRepeat,
    VOnsSelect: VOnsSelect,
    VOnsSegment: VOnsSegment,
    VOnsPullHook: VOnsPullHook,
    VOnsPage: VOnsPage
  });

  var $ons = setup(ons__default["default"]);

  $ons.install = function (Vue) {
    /**
     * Register components of vue-onsenui.
     */
    Object.keys(components).forEach(function (key) {
      return Vue.component(components[key].name, components[key]);
    });
    /**
     * Expose ons object.
     */

    Vue.prototype.$ons = $ons;
  };

  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use({
      install: $ons.install
    });
  }

  return $ons;

}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
